import script from "./SkinType.vue?vue&type=script&setup=true&lang=js"
export * from "./SkinType.vue?vue&type=script&setup=true&lang=js"

import "./SkinType.vue?vue&type=style&index=0&id=b2a101d8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b2a101d8"]])

export default __exports__